import {
  BUSINESS_TIMEZONE,
  SlotBookingConflictApiResponseError,
} from '@omecare/utils';
import { intlFormat } from 'date-fns/intlFormat';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export const useSlotBookingConflitErrorHandler = () => {
  const { t } = useTranslation();

  return {
    handle: (error: SlotBookingConflictApiResponseError) => {
      const [firstConflict] = error.data;

      const periodOfTheDay = t(
        `period-of-day.${firstConflict!.periodOfTheDay}`,
      );
      const formattedDate = intlFormat(
        firstConflict!.date,
        {
          timeZone: BUSINESS_TIMEZONE,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        },
        {
          locale: 'fr',
        },
      );
      toast.error(
        t('http.errors.agenda_slot_booking_conflict', {
          officeName: firstConflict!.officeName,
          date: formattedDate,
          periodOfTheDay,
        }),
      );
    },
  };
};
